/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![VoiceXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABGElEQVR4nOWVzUoDMRCAs/XkxVtbfaOlMJnJYZiB9l32RWyfwD5CD23xIIiCFtSnUWbXlLQWKbupCB0IhMnyffnZTJw7iwhhfONJNh5lnR1eluMrIHnypJ/WssKZ+RJIlxGeVcDMFx51nsJzCgpPersP7yQA0vtDQP+7oDhacAzcJ4KqqnqA+gEkzyFMBjFfMvcB5QFIV50EzrkCSB6bvGwAdGgiIHmxnI11Fbh6tt/A+p7Uremnq2otiBKP+rr9BuXNLqbbj7aCECaDVACk7yPm6yyCYPBkW2Lfts1W1lkApKsIrA8YdLgVoixyCGYGSmfb/Em6BJTprgBl3eYM/k+pOFjsSO5OJjh5uf6TBydGfDJ/FLCziC/C93F/jkbOIwAAAABJRU5ErkJggg==)
 */
export const VoiceXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 3a1 1 0 0 0-1-1h-.06a1 1 0 0 0-.74.32L5.92 7H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2.92l4.28 4.68a1 1 0 0 0 .74.32H11a1 1 0 0 0 1-1V3ZM22.7 8.3a1 1 0 0 0-1.4 0L19 10.58l-2.3-2.3a1 1 0 1 0-1.4 1.42L17.58 12l-2.3 2.3a1 1 0 0 0 1.42 1.4L19 13.42l2.3 2.3a1 1 0 0 0 1.4-1.42L20.42 12l2.3-2.3a1 1 0 0 0 0-1.4Z"
        className={colorClass}
      />
    </svg>
  );
};
